var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notifications-dashboard info details" },
    [
      _c("h3", [_vm._v("Project Notification Settings")]),
      _vm._v(" "),
      _c("section", [
        _c("h4", { staticClass: "block-header" }, [
          _vm._v("\n      Immediate updates\n    "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "helper-text" }, [
          _vm._v("\n      Get notified immediately on project changes\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "material-radio", on: { click: _vm.setDirty } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.immediate,
                  expression: "immediate",
                },
              ],
              attrs: { type: "radio", id: "immediateAll", value: "all" },
              domProps: { checked: _vm._q(_vm.immediate, "all") },
              on: {
                change: function ($event) {
                  _vm.immediate = "all"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "immediateAll" } }, [_vm._v("All")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "material-radio", on: { click: _vm.setDirty } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.immediate,
                  expression: "immediate",
                },
              ],
              attrs: { type: "radio", id: "immediateNone", value: "none" },
              domProps: { checked: _vm._q(_vm.immediate, "none") },
              on: {
                change: function ($event) {
                  _vm.immediate = "none"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "immediateNone" } }, [_vm._v("None")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("h4", { staticClass: "block-header" }, [
          _vm._v("\n      Daily activity summary\n    "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "helper-text" }, [
          _vm._v("\n      Receive a summary once a day\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "material-radio", on: { click: _vm.setDirty } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.daily,
                  expression: "daily",
                },
              ],
              attrs: { type: "radio", id: "dailyAll", value: "all" },
              domProps: { checked: _vm._q(_vm.daily, "all") },
              on: {
                change: function ($event) {
                  _vm.daily = "all"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "dailyAll" } }, [_vm._v("All")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "material-radio", on: { click: _vm.setDirty } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.daily,
                  expression: "daily",
                },
              ],
              attrs: { type: "radio", id: "dailyNone", value: "none" },
              domProps: { checked: _vm._q(_vm.daily, "none") },
              on: {
                change: function ($event) {
                  _vm.daily = "none"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "dailyNone" } }, [_vm._v("None")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("section", [
        _c("h4", { staticClass: "block-header" }, [
          _vm._v("\n      Regular oversight\n    "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "helper-text" }, [
          _vm._v(
            "\n      Receive eMail listing all the active projects and their status\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "daily-inputs" }, [
          _c(
            "div",
            { staticClass: "material-radio", on: { click: _vm.setDirty } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.oversight,
                    expression: "oversight",
                  },
                ],
                attrs: { type: "radio", id: "oversightDaily", value: "daily" },
                domProps: { checked: _vm._q(_vm.oversight, "daily") },
                on: {
                  change: function ($event) {
                    _vm.oversight = "daily"
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "oversightDaily" } }, [
                _vm._v("Weekly on"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "daily-options-wrap" }, [
            _c(
              "div",
              { staticClass: "daily-options" },
              _vm._l(_vm.daylyOptions, function (option) {
                return _c("app-checkbox", {
                  key: option.value,
                  staticClass: "app-checkbox",
                  attrs: {
                    value: _vm.oversightDays.includes(option.value),
                    label: option.label,
                    name: option.value.toString(),
                    isDisabled: _vm.oversight === "none",
                  },
                  on: { change: _vm.updateOversightDays },
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.errorMessage && _vm.noSelectedDays
              ? _c("div", { staticClass: "error-inline" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errorMessage) + "\n        "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "material-radio", on: { click: _vm.setDirty } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.oversight,
                  expression: "oversight",
                },
              ],
              attrs: { type: "radio", id: "oversightNone", value: "none" },
              domProps: { checked: _vm._q(_vm.oversight, "none") },
              on: {
                change: function ($event) {
                  _vm.oversight = "none"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "oversightNone" } }, [_vm._v("None")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide", mode: "out-in" } }, [
        _vm.isWarning && _vm.isDirty
          ? _c("div", { staticClass: "warning-message" }, [
              _c("p", [
                _vm._v(
                  "\n        With these settings you will not receive any updates about Asoko\n        Insight projects. Are you sure you want to continue?\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "align-center" }, [
        _c(
          "button",
          {
            staticClass: "cta-button high-button-dark",
            attrs: { disabled: _vm.isLoading },
            on: { click: _vm.saveSettings },
          },
          [
            !_vm.isLoading ? _c("span", [_vm._v("Save")]) : _vm._e(),
            _vm._v(" "),
            _vm.isLoading
              ? _c("button-spinner", {
                  staticStyle: { width: "20px", height: "20px" },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }